export class BadRequestError extends Error {
  constructor(
    public reason: string,
    public data: { [key: string]: string },
  ) {
    super(reason);
  }
}
